import React from 'react';
import cn from 'classnames';
import Layout from 'components/campus/layout';
import style from 'styles/campus/position.module.scss';
import { useState } from 'react';

const positionInfo = [
  {
    name: 'Java开发工程师',
    tag: 'Java',
    site: '武汉/西安/成都/郑州',
    annualSalary: '本科：10~12万，硕士：14~18万',
    count: '20人',
    major: '计算机，电子信息，自动化，通信，软件工程等相关专业',
    link: 'https://xylink.zhiye.com/zpdetail/270382362',
  },
  {
    name: 'C/C++开发工程师',
    tag: 'C/C++',
    site: '武汉/西安/成都/北京',
    annualSalary: '本科：10~12万，硕士：14~18万',
    count: '20人',
    major: '计算机，电子信息，自动化，通信，软件工程等相关专业',
    link: 'https://xylink.zhiye.com/zpdetail/270382365',
  },
  {
    name: '测试工程师',
    tag: '测试',
    site: '武汉/郑州/西安/成都',
    annualSalary: '本科：10~12万，硕士：14~18万',
    count: '15人',
    major: '计算机，电子信息，自动化，通信，软件工程等相关专业',
    link: 'https://xylink.zhiye.com/zpdetail/270382639',
  },
  {
    name: '前端开发工程师',
    tag: '前端',
    site: '武汉/郑州/西安/成都',
    annualSalary: '本科：10~12万，硕士：14~18万',
    count: '10人',
    major: '计算机，电子信息，自动化，通信，软件工程等相关专业',
    link: 'https://xylink.zhiye.com/zpdetail/270382638',
  },
  {
    name: '运维工程师',
    tag: '运维',
    site: '武汉/郑州/北京',
    annualSalary: '本科：10~12万，硕士：14~18万',
    count: '5人',
    major: '计算机，电子信息，自动化，通信，软件工程等相关专业',
    link: 'https://xylink.zhiye.com/zpdetail/270382634',
  },
  {
    name: '客户端开发工程师-Android',
    tag: 'Android',
    site: '武汉/西安/成都',
    annualSalary: '本科：10~12万，硕士：14~18万',
    count: '5人',
    major: '计算机，电子信息，自动化，通信，软件工程等相关专业',
    link: 'https://xylink.zhiye.com/zpdetail/270382632',
  },
  {
    name: '客户端开发工程师-iOS',
    tag: 'iOS',
    site: '西安/成都',
    annualSalary: '本科：10~12万，硕士：14~18万',
    count: '5人',
    major: '计算机，电子信息，自动化，通信，软件工程等相关专业',
    link: 'https://xylink.zhiye.com/zpdetail/270382630',
  },
  {
    name: '媒体算法工程师',
    tag: '媒体算法',
    site: '武汉/成都/北京',
    annualSalary: '本科：10~14万，硕士：14~20万',
    count: '5人',
    major: '计算机，通信，声学、信号、自动化，软件工程等相关专业',
    link: 'https://xylink.zhiye.com/zpdetail/270382625',
  },
  {
    name: 'AI开发工程师',
    tag: 'AI',
    site: '武汉',
    annualSalary: '本科：10~14万，硕士：14~20万',
    count: '5人',
    major: '计算机，电子信息，自动化，通信，软件工程等相关专业',
    link: 'https://xylink.zhiye.com/zpdetail/270382622',
  },
  {
    name: '嵌入式软件工程师',
    tag: '嵌入式',
    site: '武汉',
    annualSalary: '本科：10~12万，硕士：14~18万',
    count: '5人',
    major: '计算机，电子信息，自动化，通信，软件工程等相关专业',
    link: 'https://xylink.zhiye.com/zpdetail/270382619',
  },
  {
    name: '硬件工程师',
    tag: '硬件',
    site: '武汉',
    annualSalary: '本科：10~12万，硕士：14~18万',
    count: '5人',
    major: '计算机，电子信息，自动化，通信，软件工程等相关专业',
    link: 'https://xylink.zhiye.com/zpdetail/270382616',
  },
  {
    name: '技术支持工程师',
    tag: '技术支持',
    site: '全国',
    annualSalary: '本科：10~12万，硕士：12~16万',
    count: '20人',
    link: 'https://xylink.zhiye.com/zpdetail/270382642',
  },
  {
    name: '销售经理',
    tag: '销售',
    site: '全国',
    annualSalary: '本科：10~12万，硕士：12~16万',
    count: '40人',
    link: 'https://xylink.zhiye.com/zpdetail/270382644',
  },
];

const Position = () => {
  const [currentTag, setTag] = useState(0);
  const itemInfo = positionInfo[currentTag];
  return (
    <Layout pageKey="position">
      <div className={cn(style.content, 'for-pc')}>
        {positionInfo.map(item => {
          return (
            <div key={item.name} className={style['position-item']}>
              <div className={style.title}>{item.name}</div>
              <div className={style.info}>
                <p className={style.site}>
                  <span className={style.label}>工作地点：</span>
                  <span className={style.value}>{item.site}</span>
                </p>
                <p className={style.annualSalary}>
                  <span className={style.label}>入职年薪：</span>
                  <span className={style.value}>{item.annualSalary}</span>
                </p>
                <p className={style.count}>
                  <span className={style.label}>招聘人数：</span>
                  <span className={style.value}>{item.count}</span>
                </p>
                {item.major && (
                  <p>
                    <span className={style.label}>专业要求：</span>
                    <span className={style.value}>{item.major}</span>
                  </p>
                )}
              </div>
              <a href={item.link} className={style.btn}>
                查看详情
              </a>
            </div>
          );
        })}
      </div>
      <div className={style['tag-list']}>
        {positionInfo.map((item: any, index: number) => {
          return (
            <div className={cn(style.tag, index === currentTag && style.focus)} key={item.tag} onClick={() => setTag(index)}>
              {item.tag}
            </div>
          );
        })}
        <div className={style.position}>
          <p className={style.name}>{itemInfo.name}</p>
          <p className={style.site}>
            <span>工作地点：</span>
            {itemInfo.site}
          </p>
          <p className={style.annualSalary}>
            <span>入职年薪：</span>
            {itemInfo.annualSalary}
          </p>
          <p className={style.count}>
            <span>招聘人数：</span>
            {itemInfo.count}
          </p>
          {itemInfo.major && (
            <p>
              <span>专业要求：</span>
              {itemInfo.major}
            </p>
          )}
          <a href={itemInfo.link} className={cn(style.btn, style.btnM)}>
            查看详情
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default Position;
